export default {
  LOADING: (state) => state.isLoading,
  isError: (state) => state.error,
  ERROR: (state) => state.errorMessage,
  PATH: (state) => state.path,
  PRODUCTS: (state) => state.products,
  CATEGORY: (state) => state.category,
  VENDORS: (state) => state.vendors,
  STOCKROOM: (state) => state.stockroom,
  RULES: (state) => state.rules,
  SHOPDATA: (state) => state.shopdata,
  BILL_STOCK: (state) => state.billstock,
  BILLS: (state) => state.allBills,
  PRINT_BILLS: (state) => state.billItems,
  VENDOR_PRODUCTS: (state) => state.vendorProdList,
  STOCK_DATA: (state) => state.stockdata,
  ONLINE_CATEGORY: (state) => state.onlineCat,
  ONLINE_PRODUCTS: (state) => state.onlineProd,
  ONLINE_ORDERS: (state) => state.onlineOrders,
  ONLINE_ORDERS_ITEMS: (state) => state.onlineOrdersItems,
};
